// Module
var code = "<ktable component=\"component\" form=\"form\" ktable-validate=\"component.validate\" ng-attr-name=\"{{ componentId }}\" ng-disabled=\"readOnly || component.disabled\" ng-model=\"tmp[componentId]\" options=\"ktableOptions\" query=\"component.query\"></ktable> ";
// Exports
export default code;